<template>
    <textarea ref="textarea" :name="name" :value="localValue" @input="onInput" :placeholder="placeholder"
        :class="['input-wide', { 'is-invalid': error }]" rows="1"></textarea>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        // See InputText: bound on the <textarea> so the highlight does not
        // depend on this component's root staying the control.
        error: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localValue: this.value
        };
    },
    watch: {
        value(newVal) {
            this.localValue = newVal;
            this.$nextTick(this.resize);
        }
    },
    mounted() {
        this.resize();
    },
    methods: {
        onInput(event) {
            this.localValue = event.target.value;
            this.$emit('update:value', event.target.value);
            this.resize();
        },
        resize() {
            const el = this.$refs.textarea;
            if (!el) return;
            el.style.height = 'auto';
            el.style.height = el.scrollHeight + 'px';
        }
    }
};
</script>

<style scoped>
.input-wide {
    width: 100%;
    min-height: 100px;
    overflow-y: hidden;
    resize: none;
    box-sizing: border-box;
}
</style>